export default {
  DESIGNER: 'Designer',
  DESIGN_SYSTEM_MANAGER: 'Design System Manager',
  MANAGER_OR_DESIGN_TEAM_LEAD: 'Manager/Design Team Lead',
  PRODUCT: 'Product',
  DEVELOPER: 'Developer',
  MARKETING_SPECIALIST: 'Marketing Specialist',
  WRITER: 'Writer',
  FINANCE_OR_ADMIN: 'Finance/Admin',
  RESEARCHER: 'Researcher',
  OTHER: 'Other',
} as const
